import { render, staticRenderFns } from "./AddManualDisputeLetter.vue?vue&type=template&id=e3b6842a&"
import script from "./AddManualDisputeLetter.vue?vue&type=script&lang=js&"
export * from "./AddManualDisputeLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports